module.exports = __webpack_public_path__ + "static/media/03.0be0fed2.jpg";